import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFAutocomplete, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { Typography } from '@mui/material';

import { blockInvalidChar } from "src/helper/blockInvalidCharNumFld";

export default function CandNewEditRefCompo({ desgRefData }) {
  const genderArr = ['Male', 'Female'];
  // const [genderArr, setGenderArr] = useState([]);
  const { control, setValue, watch, resetField } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'candRef',
  });

  const handleAdd = () => {
    append({
      refSrno: 0,
      refNm: '',
      refOrgNm: '',
      refdesig: null,
      refEmail: '',
      refContact: '',
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };
  return (
    <>
      <Box
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
        }}
        mb={3}
      >
        <Typography variant="h6" sx={{ color: 'text.disabled'}}>
          Reference Details:
        </Typography>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add Reference
          </Button>
        </Stack>
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={3}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5}>
            <Typography variant="h6" sx={{ color: 'primary', mb: 2 }}>
              Reference {index + 1}:
            </Typography>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <Box sx={{ display: { xs: 'none', sm: 'none' } }}>
                <RHFTextField name={`candRef[${index}].refSrno`} />
              </Box>
              <RHFTextField
                name={`candRef[${index}].refNm`}
                label={
                  <div>
                    Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
              />
              <RHFTextField
                name={`candRef[${index}].refOrgNm`}
                label={
                  <div>
                    Employer Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
              />
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`candRef[${index}].refdesig`}
                  placeholder="Designation"
                  label={
                    <div>
                      Designation<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={desgRefData}
                  showPlusIcon
                  getOptionLabel={(option) => option.masterName}
                  //   value={selectedGender}
                  //   onChange={(event, newValue) => {
                  //     setSelectedGender(newValue);
                  //   }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
              <RHFTextField
                name={`candRef[${index}].refEmail`}
                label={
                  <div>
                    Email<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
              />
              <RHFTextField
                name={`candRef[${index}].refContact`}
                label="Mobile Number"
                type="number"
                onKeyDown={blockInvalidChar}
              />
            </Box>

            <Stack
              direction={{ xs: 'column', md: 'row' }}
              alignItems={{ xs: 'flex-end', md: 'center' }}
              justifyContent="flex-end"
            >
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
CandNewEditRefCompo.propTypes = {
  desgRefData: PropTypes.array,
};
